import { useQuery } from '@tanstack/react-query';
import { SuperAdminNotificationRecipient } from '@models/superAdminNotificationRecipient.model';
import { superAdminNotificationRecipientService } from '@services/superAdminNotificationRecipient';

export const SUPER_ADMIN_NOTIFICATION_RECIPIENTS_QUERY_KEY = [
  'super-admin-notification-recipients',
];

export const useSuperAdminNotificationRecipients = () => {
  return useQuery<SuperAdminNotificationRecipient[], Error>({
    queryKey: SUPER_ADMIN_NOTIFICATION_RECIPIENTS_QUERY_KEY,
    queryFn: () => superAdminNotificationRecipientService.getRecipients(),
    staleTime: 60 * 1000,
  });
};

export default useSuperAdminNotificationRecipients;
